import template from './login.html';
import controller from './login.controller';

let loginComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default loginComponent;



// WEBPACK FOOTER //
// ./client/app/routes/auth/login/login.component.js